import React, { Component } from 'react'
import classnames from 'classnames'
import CollectionRow from '../collection-row'

export default class CollectionRows extends Component {

  renderRow(row, index, list) {
    const { st, match, pageName } = this.props 

    const rowClassNames = classnames({
      'collection__row-outer--first': index === 0,
      'collection__row-outer--last': index === list.size - 1,
      'collection__row-outer--spread-margin': row.isSpreadMargin
    }, 'collection__row-outer')


    return (
      <div key={row.id} className={rowClassNames}>
        <CollectionRow
          pageName={pageName}
          st={st}
          match={match}
          rowIndex={index}
          rows={list}
          row={row} />
      </div>
    )
  }
  render() {
    const { rows } = this.props

    return (
      <div className="collection__rows">
        {rows && rows.map((row, index, list) => this.renderRow(row, index, list))}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/collection-list/collection-rows.js